import { cacheDom } from '../utils/QuerySelectors.js'
import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll'

const dom = {}
const qs = {
  modal: 'data-popup',
  wrapper: 'data-popup-wrapper',
  content: 'data-popup-content',
  close: 'data-popup-close',
}
const qsAll = {}

export const toggleModal = (toggle = true, content = null, node = null, clear = true, bottom = false) => {
  if (toggle) {
    disablePageScroll()
  } else {
    enablePageScroll()
  }
  if (clear) dom.content.innerHTML = ''
  if (content) dom.content.innerHTML = content
  if (!content && node) dom.content.appendChild(node)
  dom.wrapper.classList.toggle('lg:bottom-0', bottom)
  dom.wrapper.classList.toggle('lg:bottom-auto', !bottom)
  //  dom.wrapper.classList.toggle('right-0', bottom) temporary remove -phil
  dom.modal.classList.toggle('z-[-1]', !toggle)
  dom.modal.classList.toggle('opacity-0', !toggle)
  dom.modal.classList.toggle('z-full', toggle)
  dom.modal.classList.toggle('opacity-100', toggle)
  document.body.classList.toggle('overflow-hidden', toggle)
}

export const setupPopup = () => {
  cacheDom(dom, qs, qsAll)

  window.openPopup = (modalContent, modalNode = null) => {
    toggleModal(true, modalContent, modalNode)
  }

  dom.close.addEventListener('click', () => {
    toggleModal(false)
  })
  dom.wrapper.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.modal.addEventListener('click', () => {
    toggleModal(false)
  })
}
